import get from '../../../utils/accessors/get';
import keys from '../../../utils/accessors/keys';
import stateChangesMap from '../../../utils/redux/#stateChangesMap';

export default function exposeChangedState<State extends object>(state: State, statePath: string[], changes: string[]) {
  if (state && typeof state === 'object' && stateChangesMap.has(state)) {
    const stateChanges = stateChangesMap.get(state);
    changes.push(
      ...stateChanges.map((change) => {
        if (change === '.') {
          return statePath.join('.');
        }

        return (
          [...statePath, change].join('.')
        );
      }),
    );

    // TODO only update selector based on dependencies. Could only support siblings dependencies to start with.
    const selectors = get(state, '[selectors]') as Record<string, string>;
    if (selectors) {
      const selectorNames = keys(selectors);
      changes.push(
        ...selectorNames.map((selectorName) => (
          [...statePath, selectorName].join('.')
        )),
      );
    }

    stateChangesMap.delete(state);
  } else {
    changes.push(statePath.join('.'));
  }
}
